import React, { useState, useEffect } from "react";
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { SelectButton } from 'primereact/selectbutton';
import { Dropdown } from 'primereact/dropdown';
import SwitchConInput from "./fields/SwitchConInput";


const InformazioniPreliminari = (props) => {

    // lista tipi 
    const options = ['Appartamento', 'Casa indipendente', 'Locale Commerciale'];

    //  lista piani
    const piani = [
        { name: 'Seminterrato', code: -1 },
        { name: 'Piano Terra', code: 0 },
        { name: 'Piano primo', code: 1 },
        { name: 'Secondo piano', code: 2 },
        { name: 'Terzo piano', code: 3 },
        { name: 'Quarto piano', code: 4 },
        { name: 'Quinto piano', code: 5 },
        { name: 'Sesto piano', code: 6 },
        { name: 'Superiore al sesto piano', code: 7 },
    ];

    const [info, setInfo] = useState(props.preventivo.infoPrel || {
        mq: 0,
        // tipologia appartamento  o villa
        tipologia: props.tipologia === "appartamento" ? options[0] : options[1],
        // piano selezionato 
        pianoSelezionato: null
    })

    const [amministrazione, setAmministrazione] = useState(props.preventivo.amministrazione || {
        title: "Amministrazione",
        cila: {
            tipologia: "SwitchConInput",
            titolo: "Cila",
            descrizione: `La CILA (Comunicazione di Inizio Lavori Asseverata) è un documento amministrativo che deve essere presentato al Comune prima di iniziare determinati lavori edilizi o di ristrutturazione, come previsto dalla normativa italiana. La CILA viene compilata da un tecnico abilitato (ad esempio un architetto o un ingegnere) e contiene informazioni dettagliate sul progetto di costruzione o di ristrutturazione, comprese le caratteristiche dell'opera, i materiali utilizzati, i calcoli strutturali, e così via. La presentazione della CILA è obbligatoria per ottenere l'autorizzazione comunale all'inizio dei lavori.`,
            valore: false,
            quantita: 1,
            hideInput: true,
            descrizioneQuantita: "unità",
            descQuantita: "u",
            prezzo: 100,
            totale: 0,
        },
        direzione: {
            tipologia: "SwitchConInput",
            titolo: "Direzione dei lavori",
            descrizione: `La Direzione Lavori è una figura professionale incaricata di sovrintendere e gestire l'intero processo di realizzazione di un'opera edile, dall'inizio alla fine. La Direzione Lavori viene nominata dal committente (il proprietario dell'immobile o il promotore del progetto) e può essere svolta da un architetto o un ingegnere. Le principali responsabilità della Direzione Lavori includono:Controllo dell'esecuzione dei lavori,Gestione delle risorse, Sorveglianza della sicurezza, Gestione delle modifiche al progetto, Rapporti con le autorità competenti `,
            valore: false,
            quantita: 1,
            hideInput: true,
            descrizioneQuantita: "unità",
            descQuantita: "u",
            prezzo: 100,
            totale: 0,
        }
    })

    // tetto solo per casa indipendete
    const [rifacimentoTetto, setRifacimentoTetto] = useState(props.preventivo.rifacimentoTetto || {
        title: "Rifacimento Tetto",
        rifacimentoTetto: {
            tipologia: "SwitchConInput",
            titolo: "Rifacimento Tetto",
            descrizione: `Valutazione e progettazione, Acquisizione dei materiali e degli strumenti, Preparazione del tetto e del sottotetto, Installazione della struttura portante, Applicazione del rivestimento impermeabilizzante, Installazione del materiale di copertura, Finiture e dettagli, Ispezione e verifica`,
            valore: false,
            quantita: 0,
            descrizioneQuantita: "Metri quadrati",
            descQuantita: "mq",
            prezzo: 100,
            totale: 0,
        }
    })

    useEffect(() => {
        props.onChange(info, rifacimentoTetto, amministrazione)
    }, [info, rifacimentoTetto, amministrazione])

    /* divisore*/
    const divider = (<div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>)

    const itemTemplate = (option) => {
        return <div className="w-10rem">{option}</div>;
    }
    return (
        <>
            <div className="surface-ground px-1 py-1 md:px-4 md:py-4">
                <div className="text-900 font-medium text-900 text-xl mb-2">Informazioni Preliminari</div>
                <p className="m-0 mb-2 p-0 text-600 line-height-3 mr-3">Scegli la tipologia di casa, metri quadri e il piano</p>
                <div className="surface-card p-4 shadow-2 border-round ">

                    <div className="grid formgrid p-fluid">
                        <div className="card flex justify-content-center mb-5">
                            <SelectButton value={info.tipologia} itemTemplate={itemTemplate}
                                className="flex-column md:flex-row"

                                onChange={(e) => {
                                    setInfo({ ...info, tipologia: e.value });
                                    setRifacimentoTetto({
                                        ...rifacimentoTetto,
                                        rifacimentoTetto: {
                                            ...rifacimentoTetto.rifacimentoTetto,
                                            valore: e.value === "Casa indipendente" ? false : rifacimentoTetto.rifacimentoTetto.valore,
                                            totale: (e.value === "Casa indipendente" || !rifacimentoTetto.rifacimentoTetto.valore) ? 0 : rifacimentoTetto.rifacimentoTetto.quantita * rifacimentoTetto.rifacimentoTetto.prezzo
                                        }
                                    })
                                }}
                                options={options} />
                        </div>

                        {divider}

                        {/*MQ - INPUTNUMBER**/}
                        <div className="field mb-4 col-12 md:col-6 flex flex-column">
                            <label htmlFor="mq" className="font-medium text-900">Metri quadrati</label>
                            <InputNumber id="mq" value={info.mq} prefix="mq " placeholder="mq"
                                onChange={(e) => {
                                    setInfo({ ...info, mq: e.value })
                                    setRifacimentoTetto({
                                        ...rifacimentoTetto,
                                        rifacimentoTetto: {
                                            ...rifacimentoTetto.rifacimentoTetto,
                                            quantita: e.value,
                                            totale: rifacimentoTetto.rifacimentoTetto.valore ? e.value * rifacimentoTetto.rifacimentoTetto.prezzo : 0
                                        }
                                    })
                                }}
                                min="0" maxFractionDigits={2} locale="it-IT" className="w-full md:w-14rem" />
                        </div>
                        <div className="field mb-4 col-12 md:col-6">
                            <label htmlFor="piano" className="font-medium text-900">Scegliere il piano</label>
                            <Dropdown id="piano" value={info.pianoSelezionato}
                                onChange={(e) => setInfo({ ...info, pianoSelezionato: e.value })}
                                options={piani} optionLabel="name"
                                placeholder="Seleziona un piano" className="w-full md:w-14rem" />
                        </div>

                        {info.tipologia === "Casa indipendente" &&
                            <>
                                {divider}

                                <div className="field mb-4 col-12 ">
                                    <label htmlFor="tetto" className="font-medium text-900">{rifacimentoTetto.rifacimentoTetto.titolo}</label>
                                    <div className="flex align-items-start flex-column">
                                        <InputSwitch inputId="tetto" checked={rifacimentoTetto.rifacimentoTetto.valore}
                                            onChange={(e) =>
                                                setRifacimentoTetto({
                                                    ...rifacimentoTetto,
                                                    rifacimentoTetto: {
                                                        ...rifacimentoTetto.rifacimentoTetto,
                                                        valore: e.value,
                                                        totale: e.value ? rifacimentoTetto.rifacimentoTetto.quantita * rifacimentoTetto.rifacimentoTetto.prezzo : 0
                                                    }
                                                })
                                            }
                                        />
                                        <span className="mt-2 ml-2">{rifacimentoTetto.rifacimentoTetto.descrizione}</span>
                                    </div>
                                </div>
                            </>
                        }
                        {divider}
                        <SwitchConInput
                            field={amministrazione.cila}
                            onChange={(data) => {
                                setAmministrazione({ ...amministrazione, cila: data });
                            }}
                        />
                        {divider}
                        <SwitchConInput
                            field={amministrazione.direzione}
                            onChange={(data) => {
                                setAmministrazione({ ...amministrazione, direzione: data });
                            }}
                        />

                    </div>
                </div>
            </div>

        </>
    )

}
export default InformazioniPreliminari